import React, { useEffect, useRef, useState } from "react";
import "./UserSubmissionDetails.scss";
import {
  GreyBorderButton,
  RedBackgroundButton,
} from "../../Global/GlobalButton";
import { RedMainHeading } from "../../Global/GlobalText";
import {
  InputLabel,
  InputTextarea,
  InputType,
  SelectBorder,
} from "../../Global/GlobalFormElement";
import { UserTopBanner } from "../../Global/User-Flow/UserTopBanner/UserTopBanner";
import { UserBottomBar } from "../../Global/User-Flow/UserBottomBar/UserBottomBar";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import axios from "axios";
import { EXCHNAGE_URL, EXHANGE_URL_IMAGE_UPLOAD } from "../../../Url/Url";
import { toast } from "react-toastify";
import { Modal, Button } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import imageCompression from "browser-image-compression";
import { useLoading } from "../../LoadingContext";

const countries = [
  "United States",
  "Canada",
  "United Kingdom",
  "Australia",
  "India",
  "Germany",
  "France",
  "Italy",
  "Spain",
  "Mexico",
  "Japan",
  "South Korea",
  "Brazil",
  "China",
  "South Africa",
  "Russia",
  "Netherlands",
  "Sweden",
  "Switzerland",
  "Belgium",
];

export const UserSubmissionDetails = () => {
  const [formData, setFormData] = useState({});
  // 🔒 FIX: current submission_id ko yahan store karte hain, taaki
  // "Save as Draft" ya "Submit" har baar NAYA submission_id generate na kare
  const [currentSubmissionId, setCurrentSubmissionId] = useState(null);
  // 🔒 FIX: pehle se upload ki hui files ka record — { dataName: [{file_name, file_url}] }
  // taaki draft/edit form khulte hi "already uploaded: filename" dikhaya ja sake
  const [uploadedMediaFiles, setUploadedMediaFiles] = useState({});
  const [formSchema, setFormSchema] = useState([]);
  const [errors, setErrors] = useState({});
  const [categories, setCategories] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [sortOrder, setSortOrder] = useState("newest");
  const [selectedAwardId, setSelectedAwardId] = useState();
  const [selectedCategoryName, setSelectedCategoryName] = useState("");
  const userRole = useSelector((state) => state?.users?.user?.role);

  const navigate = useNavigate();
  const location = useLocation();
  const { setLoading } = useLoading();
  const {
    eventId,
    entryFormId,
    event_logo,
    event_banner,
    closing_date,
    closing_time,
    event_name,
  } = location.state || {};
  const [isCancelModalOpen, setIsCancelModalOpen] = useState(false);

  const openCancelModal = () => {
    setIsCancelModalOpen(true);
  };

  const closeCancelModal = () => {
    setIsCancelModalOpen(false);
  };

  const handleCancel = () => {
    setFormData({});
    setIsCancelModalOpen(false);
    toast.info("Form submission canceled.");
    if (userRole === "admin") {
      navigate("/dashboard");
    } else {
      navigate("/user-dashboard");
    }
  };

  const handleEntryForm = async () => {
    setIsLoading(true);
    try {
      const response = await axios.get(
        `${EXCHNAGE_URL}/entryForm?eventId=${eventId}&entryFormId=${entryFormId}`,
        {
          headers: {
            "Content-Type": "application/json",
            authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        },
      );
      if (response.status === 200) {
        toast.success("Entry form fetched successfully");
        const fetchedFields = response.data.data.form_schema;
        const jsonArray = JSON.parse(fetchedFields);
        setFormSchema(jsonArray);
      } else {
        toast.error("Failed to fetch the Entry form.");
      }
    } catch (error) {
      console.error("Error fetching data:", error.message);
    } finally {
      setIsLoading(false);
    }
  };

  const hasFetchedOnce = useRef(false);

  useEffect(() => {
    if (!hasFetchedOnce.current) {
      handleEntryForm();
      hasFetchedOnce.current = true;
    }
  }, []);



////---------------------------------------DRAFT LOGIC --------------------------//


const handleSaveDraft = async () => {
  try {
    setLoading(true);

    // ⚠️ validation skip (draft me allow empty)
    await uploadFilesToBackend();

    const convertedData = convertFormDataToSimpleObject(formData);

    const formPayload = {
      fields: convertedData,
      eventId,
      entryFormId,
      awardcatId: parseInt(selectedAwardId || 0, 10),
      isDraft: true, // 🔥 MAIN FLAG
      // 🔒 FIX: agar pehle se hi ek submission_id hai (pehli draft-save ya
      // page-load pe existing draft se mila hua), to wahi bhejo — taaki
      // backend NAYA ID generate karne ki jagah usi record ko update kare.
      ...(currentSubmissionId ? { submissionId: currentSubmissionId } : {}),
    };

    const draftResponse = await axios.post(`${EXCHNAGE_URL}/entryForm_submission`, formPayload, {
      headers: {
        "Content-Type": "application/json",
        authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });

    // 🔒 FIX: backend jo submissionId return karta hai use state me save karo,
    // taaki agli "Save as Draft" ya final "Submit" isi ID ko reuse kare.
    if (draftResponse?.data?.submissionId) {
      setCurrentSubmissionId(draftResponse.data.submissionId);
    }

    toast.success("Draft saved successfully ✅");


    //--------------Navigation ------------//
      if (userRole === "admin") {
      navigate("/dashboard");
    } else {
      navigate("/user-dashboard");
    }




  } catch (error) {
    console.error(error);
    toast.error("Draft save failed ❌");
  } finally {
    setLoading(false);
  }
};




  useEffect(() => {
    if (formSchema.length > 0) {
      const initialData = formSchema.reduce((acc, field) => {
        acc[field.dataName] = {
          value: field.defaultValue || "",
          isConditionMet: field.isConditionMet,
          isRequired: field.isRequired || false,
          label: field.label,
          isVisible: field.visible || true,
          dataName: field.dataName || "",
          selectedLabelPosition: field.selectedLabelPosition || "",
          visible: field.isVisibleIf ? false : field.visible || true,
          isVisibleIf: field.isVisibleIf,
          uploadFileSize: field.uploadFileSize || "",
          uploadFileType: field.uploadFileType ? [...field.uploadFileType] : [],
          type: field.type, // Add type to formData
        };
        return acc;
      }, {});
      setFormData(initialData);
    }
  }, [formSchema]);

  const getCategories = async () => {
    setIsLoading(true);
    try {
      let apiUrl = `${EXCHNAGE_URL}/userformcategorylist?eventId=${eventId}&sortOrder=${sortOrder}`;
      if (searchTerm) {
        apiUrl += `&search=${searchTerm}`;
      }
      const response = await axios.get(apiUrl, {
        headers: {
          "Content-Type": "application/json",
          authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });
      if (response.status === 200) {
        setCategories(response.data.data);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getCategories();
  }, [eventId, searchTerm, sortOrder]);

  const handleRadioAndDropDown = (name, value) => {
    setFormData((prev) => ({
      ...prev,
      [name]: {
        ...prev[name],
        value,
      },
    }));
  };

  const handleCheckboxChange = (name, option) => {
    setFormData((prev) => {
      const currentValue = prev[name]?.value;
      return {
        ...prev,
        [name]: {
          ...prev[name],
          value: currentValue === option ? "" : option,
        },
      };
    });
  };

  const handlePosition = () => {
    formSchema.forEach((field) => {
      const { selectedLabelPosition, dataName } = field;
      const fieldToCheck = formData[dataName];
      if (
        fieldToCheck &&
        fieldToCheck.selectedLabelPosition !== selectedLabelPosition
      ) {
        setFormData({
          ...formData,
          [dataName]: {
            ...fieldToCheck,
            selectedLabelPosition: selectedLabelPosition,
          },
        });
      }
    });
  };

  const handleFileChange = async (event, dataName) => {
    const file = event.target.files[0];
    if (!file) return;

    const field = formData[dataName];
    if (!field) return;

    const maxSizeMB = parseFloat(field.uploadFileSize) || 10;
    const allowedTypes = field.uploadFileType || [];

    const fileSizeMB = file.size / (1024 * 1024);
    if (fileSizeMB > maxSizeMB) {
      toast.error(`File size should not exceed ${maxSizeMB} MB`);
      return;
    }

    const fileExtension = `.${file.name.split(".").pop()}`.toLowerCase();
    if (allowedTypes.length > 0 && !allowedTypes.includes(fileExtension)) {
      toast.error(
        `Invalid file type. Allowed types: ${allowedTypes.join(", ")}`,
      );
      return;
    }

    let processedFile = file;
    if (file.type.startsWith("image/")) {
      try {
        const options = {
          maxSizeMB: maxSizeMB,
          maxWidthOrHeight: 1024,
          useWebWorker: true,
        };
        processedFile = await imageCompression(file, options);
      } catch (error) {
        console.error("Error compressing image:", error);
        toast.error("Failed to compress image. Please try again.");
        return;
      }
    }

    const processedFileSizeMB = processedFile.size / (1024 * 1024);
    if (processedFileSizeMB > maxSizeMB) {
      toast.error(`File size after compression exceeds ${maxSizeMB} MB.`);
      return;
    }

  setFormData((prevData) => ({
    ...prevData,
    [dataName]: {
      ...prevData[dataName],
      file: processedFile,
      valid: true,
      // ✅ FIX: value ko file name se set karo
      value: processedFile.name, // 👈 YEH CHANGE KARO
    },
  }));
    toast.success("File selected successfully.");
  };

  const uploadFilesToBackend = async () => {
    const fileFields = Object.entries(formData).filter(
      ([_, field]) => field.type === "file" && field.file,
    );

    if (!fileFields.length) return [];

    const formDataToSend = new FormData();
    fileFields.forEach(([dataName, field]) => {
      formDataToSend.append(dataName, field.file, field.file.name);
    });
    formDataToSend.append("eventid", eventId);
    formDataToSend.append("formid", entryFormId);

    try {
      const response = await axios.post(
        `${EXHANGE_URL_IMAGE_UPLOAD}/media`,
        formDataToSend,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        },
      );

      const uploadedFiles = response.data.files.map((file) => ({
        dataName: file.field,
        mediaId: file.id,
        s3Key: `uploads/${file.field}`, // Match backend s3Key format
      }));

      // Update formData with media IDs
      uploadedFiles.forEach(({ dataName, mediaId, s3Key }) => {
        setFormData((prev) => ({
          ...prev,
          [dataName]: {
            ...prev[dataName],
            value: mediaId, // Store media ID as value
            file: null, // Clear file after upload
          },
        }));
      });

      return uploadedFiles;
    } catch (error) {
      console.error("Error uploading files to backend:", error);
      toast.error("Failed to upload files. Please try again.");
      throw error;
    }
  };

  // const checkRequiredCondition = () => {
  //   let updated = false;
  //   formSchema.forEach((field) => {
  //     const {
  //       requiredFieldValue = [],
  //       requiredConditionValue = [],
  //       requiredCriteriaPattern = "",
  //       dataName,
  //       requiredCondition = "Equals",
  //     } = field;

  //     const fieldValues = Array.isArray(requiredFieldValue)
  //       ? requiredFieldValue
  //       : [requiredFieldValue];
  //     const conditionValues = Array.isArray(requiredConditionValue)
  //       ? requiredConditionValue
  //       : [requiredConditionValue];

  //     if (
  //       !fieldValues.length ||
  //       !conditionValues.length ||
  //       !dataName ||
  //       !requiredCriteriaPattern
  //     )
  //       return;

  //     const relatedFieldKey = dataName;
  //     const relatedField = formData[relatedFieldKey];

  //     if (!relatedField) return;

  //     const patternTokens = requiredCriteriaPattern
  //       .split(/\s+/)
  //       .filter((part) => part.trim() !== "");
  //     const conditionIndexes = patternTokens
  //       .map((token, idx) => (isNaN(token) ? null : parseInt(token) - 1))
  //       .filter((idx) => idx !== null);

  //     if (conditionIndexes.length === 0) return;

  //     const evaluateCondition = (index) => {
  //       if (index < 0 || index >= fieldValues.length) return false;
  //       const fieldToCheck = Object.values(formData).find(
  //         (field) => field.label === fieldValues[index],
  //       );
  //       if (!fieldToCheck) return false;

  //       const valueToCheck = fieldToCheck.value;
  //       const expectedValue = conditionValues[index] || conditionValues[0];

  //       switch (requiredCondition) {
  //         case "Equals":
  //           return valueToCheck === expectedValue;
  //         case "contains":
  //           return valueToCheck.includes(expectedValue);
  //         case "startsWith":
  //           return valueToCheck.startsWith(expectedValue);
  //         case "endsWith":
  //           return valueToCheck.endsWith(expectedValue);
  //         case "not-contains":
  //           return !valueToCheck.includes(expectedValue);
  //         case "not-startsWith":
  //           return !valueToCheck.startsWith(expectedValue);
  //         case "not-endsWith":
  //           return !valueToCheck.endsWith(expectedValue);
  //         default:
  //           return valueToCheck === expectedValue;
  //       }
  //     };

  //     let conditionMet = false;
  //     if (patternTokens.includes("AND")) {
  //       conditionMet = conditionIndexes.every((index) =>
  //         evaluateCondition(index),
  //       );
  //     } else if (patternTokens.includes("OR")) {
  //       conditionMet = conditionIndexes.some((index) =>
  //         evaluateCondition(index),
  //       );
  //     } else {
  //       conditionMet = evaluateCondition(conditionIndexes[0]);
  //     }

  //     if (relatedField.isRequired !== conditionMet) {
  //       setFormData((prevFormData) => ({
  //         ...prevFormData,
  //         [relatedFieldKey]: {
  //           ...relatedField,
  //           isRequired: conditionMet,
  //         },
  //       }));
  //       updated = true;
  //     }
  //   });

  //   if (!updated) {
  //     return;
  //   }
  // };


  const checkRequiredCondition = () => {
  let updated = false;
  
  formSchema.forEach((field) => {
    const {
      requiredFieldValue = [],
      requiredConditionValue = [],
      requiredCriteriaPattern = "",
      dataName,
      requiredCondition = "Equals",
    } = field;

    // ✅ PEHLE relatedField define karo
    const relatedFieldKey = dataName;
    const relatedField = formData[relatedFieldKey];
    if (!relatedField) return;

    // ✅ CHANGE 1: Check karo agar condition hai ya nahi
    const hasCondition = requiredFieldValue.length > 0 &&
                         requiredConditionValue.length > 0 &&
                         requiredCriteriaPattern !== "";

    // ✅ CHANGE 2: Agar condition nahi hai toh normal required field
    if (!hasCondition) {
      const isRequiredFromSchema = field.required === true || field.isRequired === true;

      if (relatedField.isRequired !== isRequiredFromSchema) {
        setFormData((prevFormData) => ({
          ...prevFormData,
          [relatedFieldKey]: {
            ...relatedField,
            isRequired: isRequiredFromSchema,
            isConditionMet: true,
          },
        }));
        updated = true;
      }
      return; // ✅ Yahan se return karo, neeche mat jao
    }

    // ✅ BAAKI KA CODE (Condition wale fields ke liye)
    const fieldValues = Array.isArray(requiredFieldValue)
      ? requiredFieldValue
      : [requiredFieldValue];
    const conditionValues = Array.isArray(requiredConditionValue)
      ? requiredConditionValue
      : [requiredConditionValue];

    if (!fieldValues.length || !conditionValues.length || !dataName || !requiredCriteriaPattern) {
      return;
    }

    const patternTokens = requiredCriteriaPattern
      .split(/\s+/)
      .filter((part) => part.trim() !== "");
    const conditionIndexes = patternTokens
      .map((token) => (isNaN(token) ? null : parseInt(token) - 1))
      .filter((idx) => idx !== null && idx >= 0 && idx < fieldValues.length);

    if (conditionIndexes.length === 0) return;

    const evaluateCondition = (index) => {
      if (index < 0 || index >= fieldValues.length) return false;
      
      // ✅ FIX: label ki jagah dataName se compare karo
      const conditionFieldName = fieldValues[index];
      const fieldToCheck = Object.values(formData).find(
        (field) => field.dataName === conditionFieldName
      );
      
      if (!fieldToCheck) return false;

      const valueToCheck = fieldToCheck.value || "";
      const expectedValue = conditionValues[index] || conditionValues[0] || "";

      switch (requiredCondition) {
        case "Equals":
          return String(valueToCheck) === String(expectedValue);
        case "contains":
          return String(valueToCheck).toLowerCase().includes(String(expectedValue).toLowerCase());
        case "startsWith":
          return String(valueToCheck).toLowerCase().startsWith(String(expectedValue).toLowerCase());
        case "endsWith":
          return String(valueToCheck).toLowerCase().endsWith(String(expectedValue).toLowerCase());
        case "not-contains":
          return !String(valueToCheck).toLowerCase().includes(String(expectedValue).toLowerCase());
        case "not-startsWith":
          return !String(valueToCheck).toLowerCase().startsWith(String(expectedValue).toLowerCase());
        case "not-endsWith":
          return !String(valueToCheck).toLowerCase().endsWith(String(expectedValue).toLowerCase());
        default:
          return String(valueToCheck) === String(expectedValue);
      }
    };

    let conditionMet = false;
    if (patternTokens.includes("AND")) {
      conditionMet = conditionIndexes.every((index) => evaluateCondition(index));
    } else if (patternTokens.includes("OR")) {
      conditionMet = conditionIndexes.some((index) => evaluateCondition(index));
    } else {
      conditionMet = evaluateCondition(conditionIndexes[0]);
    }

    if (relatedField.isRequired !== conditionMet) {
      setFormData((prevFormData) => ({
        ...prevFormData,
        [relatedFieldKey]: {
          ...relatedField,
          isRequired: conditionMet,
          isConditionMet: conditionMet,
        },
      }));
      updated = true;
    }
  });
};
  const checkVisibilityCondition = () => {
    formSchema.forEach((fieldPayloadItem) => {
      const {
        visibleFieldValue = [],
        visibleConditionValue = [],
        visibleCriteriaPattern = "",
        dataName = "",
        visibleCondition = "Equals",
        isVisibleIf = true,
      } = fieldPayloadItem;

      const fieldValues = Array.isArray(visibleFieldValue)
        ? visibleFieldValue
        : [visibleFieldValue];
      const conditionValues = Array.isArray(visibleConditionValue)
        ? visibleConditionValue
        : [visibleConditionValue];

      if (
        !fieldValues.length ||
        !conditionValues.length ||
        !dataName ||
        !visibleCriteriaPattern
      )
        return;

      const relatedFieldKey = dataName;
      const relatedField = formData[relatedFieldKey];

      if (!relatedField) return;

      const patternTokens = visibleCriteriaPattern
        .split(/\s+/)
        .filter((part) => part.trim() !== "");
      const conditionIndexes = patternTokens
        .map((token, idx) => (isNaN(token) ? null : parseInt(token) - 1))
        .filter((idx) => idx !== null);

      if (conditionIndexes.length === 0) return;

      const evaluateCondition = (index) => {
        if (index < 0 || index >= fieldValues.length) return false;
        const fieldToCheck = Object.values(formData).find(
          (field) => field.dataName === fieldValues[index],
        );
        if (!fieldToCheck) return false;

        const valueToCheck = fieldToCheck.value;
        const expectedValue = conditionValues[index] || conditionValues[0];

        switch (visibleCondition) {
          case "Equals":
            return valueToCheck === expectedValue;
          case "contains":
            return valueToCheck.includes(expectedValue);
          case "startsWith":
            return valueToCheck.startsWith(expectedValue);
          case "endsWith":
            return valueToCheck.endsWith(expectedValue);
          case "not-contains":
            return !valueToCheck.includes(expectedValue);
          case "not-startsWith":
            return !valueToCheck.startsWith(expectedValue);
          case "not-endsWith":
            return !valueToCheck.endsWith(expectedValue);
          default:
            return valueToCheck === expectedValue;
        }
      };

      let conditionMet = false;
      if (patternTokens.includes("AND")) {
        conditionMet = conditionIndexes.every((index) =>
          evaluateCondition(index),
        );
      } else if (patternTokens.includes("OR")) {
        conditionMet = conditionIndexes.some((index) =>
          evaluateCondition(index),
        );
      } else {
        conditionMet = evaluateCondition(conditionIndexes[0]);
      }

      const newVisibility = isVisibleIf ? conditionMet : relatedField.visible;

      if (relatedField.visible !== newVisibility) {
        setFormData((prevFormData) => ({
          ...prevFormData,
          [relatedFieldKey]: {
            ...relatedField,
            visible: newVisibility,
          },
        }));
      }
    });
  };

  useEffect(() => {
    checkRequiredCondition();
    checkVisibilityCondition();
    handlePosition();
  }, [formSchema, formData]);

  const handleRadioChange = (fieldName, value) => {
    setFormData({
      ...formData,
      [fieldName]: value,
    });
  };

  const handleInputChange = (dataName, value) => {
    setFormData((prevData) => {
      const updatedData = {
        ...prevData,
        [dataName]: {
          ...prevData[dataName],
          value: value,
        },
      };
      return updatedData;
    });
  };

  // const handleCategoryChange = (e, dataName, value) => {
  //   const selectedCategoryName = e.target.value;
  //   const selectedAwardId =
  //     e.target.options[e.target.selectedIndex].getAttribute("data-award-id");

  //   setSelectedCategoryName(selectedCategoryName);
  //   setSelectedAwardId(selectedAwardId);
  //   setFormData((prevData) => {
  //     const updatedData = {
  //       ...prevData,
  //       [dataName]: {
  //         ...prevData[dataName],
  //         value,
  //       },
  //     };
  //     return updatedData;
  //   });
  // };
const handleCategoryChange = (e, dataName, value) => {
  const selectedCategoryName = e.target.value;

  const selectedAwardId = Number(
    e.target.options[e.target.selectedIndex].getAttribute("data-award-id")
  );

  setSelectedCategoryName(selectedCategoryName);
  setSelectedAwardId(selectedAwardId);

  console.log("NEW CATEGORY:", selectedCategoryName);
  console.log("NEW AWARD ID:", selectedAwardId);

  setFormData((prevData) => ({
    ...prevData,
    [dataName]: {
      ...prevData[dataName],
      value,
    },
  }));
};
  const renderField = (field) => {
    const relatedField = formData[field.dataName];
    if (!relatedField?.isConditionMet) return null;

    const requiredConditionMet = checkRequiredCondition(field);
    const fieldClass = relatedField?.isVisible ? "show" : "hide";

    handlePosition(relatedField);
    const labelPositionLeft = relatedField?.selectedLabelPosition === "left";

    const fieldPayloadItem = formSchema?.find(
      (item) => item.dataName === field.dataName,
    );
    const fieldWidth = fieldPayloadItem?.selectedFieldSize || "100%";
const isInlineField =
  field.type === "radio" || field.type === "checkbox";

const fieldStyle = {
  display: "flex",
  flexDirection: isInlineField
    ? "row"
    : labelPositionLeft
    ? "row"
    : "column",
  alignItems: isInlineField
    ? "center"
    : labelPositionLeft
    ? "center"
    : "flex-start",
  gap: "12px",
};

const labelStyle = {
  marginRight: isInlineField ? "10px" : labelPositionLeft ? "10px" : "0",
  width: isInlineField
    ? "180px"
    : labelPositionLeft
    ? "55%"
    : "auto",
  textAlign: "left",
};

    const inputStyle = {
      width: fieldWidth,
      marginLeft: labelPositionLeft ? "0" : "0",
    };

    const labelText = field.label || relatedField?.label;
    const containsHTML = /<[a-z][\s\S]*>/i.test(labelText);

    let hasRendered = false;
    const hoverHint =
      formSchema.find((item) => item.dataName === field.dataName)?.hoverHint ||
      "";

    if (!relatedField.visible) return null;
    if (!field.isVisibleIf && !field.visible) return null;

    return (
      <div className={relatedField.visible ? "show" : "hide"}>
        <div key={field.dataName} className="form-field" style={fieldStyle}>
        <label style={labelStyle}>
  {/* ✅ HTML support for label */}
  {/<[a-z][\s\S]*>/i.test(labelText) ? (
    <span 
      className="form-label-html"
      dangerouslySetInnerHTML={{ __html: labelText }} 
    />
  ) : (
    labelText
  )}
  
  {(relatedField?.isRequired ||
    (relatedField?.isRequired === false &&
      formSchema?.some(
        (item) =>
          item.dataName === field.dataName &&
          (!item.requiredConditionValue ||
            item.requiredConditionValue.every(
              (val) => val.trim() === "",
            )) &&
          item.required,
      ))) && <span style={{ color: "red" }}>*</span>}
  
  {hoverHint && (
    <span className="hover-hint-icon" title={hoverHint}>
      ?
    </span>
  )}
</label>

          {(() => {
            switch (field.type) {
              case "dropdown":
                if (!hasRendered) {
                  hasRendered = true;
                  if (field.label === "Category") {
                    return (
                      <SelectBorder
                        name="category"
                        value={selectedCategoryName}
                        onChange={(e) =>
                          handleCategoryChange(
                            e,
                            field.dataName,
                            e.target.value,
                          )
                        }
                      >
                        <option value="">Select a Category</option>
                        {categories.map((category) => (
                          <option
                            key={category.awardId}
                            data-award-id={category.awardId}
                            value={category.category_name}
                          >
                            {category.category_name}
                          </option>
                        ))}
                      </SelectBorder>
                    );
                  } else {
                    return (
                      <SelectBorder
                        value={relatedField?.value || ""}
                        onChange={(e) =>
                          handleRadioAndDropDown(field.dataName, e.target.value)
                        }
                        required={
                          requiredConditionMet || relatedField?.isRequired
                        }
                        style={inputStyle}
                      >
                        <option value="">Select an Option</option>
                        {field.options?.map((option, index) => (
                          <option key={index} value={option}>
                            {option}
                          </option>
                        ))}
                      </SelectBorder>
                    );
                  }
                }
                break;
              case "text":
                if (!hasRendered) {
                  hasRendered = true;
                  if (field.label === "Category") {
                    return (
                      <SelectBorder
                        name="category"
                        value={selectedCategoryName}
                        onChange={handleCategoryChange}
                      >
                        <option value="">Select a Category</option>
                        {categories.map((category) => (
                          <option
                            key={category.awardId}
                            data-award-id={category.awardId}
                            value={category.category_name}
                          >
                            {category.category_name}
                          </option>
                        ))}
                      </SelectBorder>
                    );
                  } else {
                    return (
                      <InputType
                        type="text"
                        placeholder={field.placeholder || ""}
                        value={relatedField?.value || ""}
                        onChange={(e) =>
                          handleInputChange(field.dataName, e.target.value)
                        }
                        required={
                          requiredConditionMet || relatedField?.isRequired
                        }
                        style={inputStyle}
                      />
                    );
                  }
                }
                break;
              case "textarea":
                if (!hasRendered) {
                  hasRendered = true;
                  return (
                    <InputTextarea
                      placeholder={
                        field.placeholder || field.defaultValue || ""
                      }
                      value={relatedField?.value || ""}
                      onChange={(e) =>
                        handleInputChange(field.dataName, e.target.value)
                      }
                      required={
                        requiredConditionMet || relatedField?.isRequired
                      }
                      style={{ ...inputStyle, height: "100px" }}
                    />
                  );
                }
                break;
             case "radio":
  if (!hasRendered) {
    hasRendered = true;
    return (
<div style={{ display: "flex", gap: "6px", flexWrap: "nowrap" }}>        {field.options &&
          field.options.map((option, index) => (
            <div
              key={index}
              className="radio_option"
              style={{ display: "flex", alignItems: "center", gap: "5px" }}
            >
              <InputType
                type="radio"
                name={field.dataName}
                value={option}
                checked={relatedField?.value === option}
                onChange={() =>
                  handleRadioAndDropDown(field.dataName, option)
                }
                required={
                  requiredConditionMet || relatedField?.isRequired
                }
                style={inputStyle}
              />
              <label>{option}</label>
            </div>
          ))}
      </div>
    );
  }
  break;

case "checkbox":
  if (!hasRendered) {
    hasRendered = true;
    return (
<div style={{ display: "flex", gap: "12px", flexWrap: "nowrap" }}>        {field.options &&
          field.options.map((option, index) => (
            <div
              key={index}
              className="checkbox_option"
              style={{ display: "flex", alignItems: "center", gap: "5px" }}
            >
              <InputType
                type="checkbox"
                name={field.dataName}
                value={option}
                checked={relatedField?.value === option}
                onChange={() =>
                  handleCheckboxChange(field.dataName, option)
                }
                required={
                  requiredConditionMet || relatedField?.isRequired
                }
                style={inputStyle}
              />
              <label>{option}</label>
            </div>
          ))}
      </div>
    );
  }
  break;
              case "email":
                if (!hasRendered) {
                  hasRendered = true;
                  return (
                    <InputType
                      type="email"
                      placeholder={field.placeholder || ""}
                      value={relatedField?.value || ""}
                      onChange={(e) =>
                        handleInputChange(field.dataName, e.target.value)
                      }
                      required={
                        requiredConditionMet || relatedField?.isRequired
                      }
                      style={inputStyle}
                    />
                  );
                }
                break;
              case "tel":
                if (!hasRendered) {
                  hasRendered = true;
                  return (
                    <InputType
                      type="number"
                      placeholder={field.placeholder || "Enter phone number"}
                      value={relatedField?.value || ""}
                      onChange={(e) =>
                        handleInputChange(field.dataName, e.target.value)
                      }
                      required={
                        requiredConditionMet || relatedField?.isRequired
                      }
                      style={inputStyle}
                    />
                  );
                }
                break;
              case "date":
                if (!hasRendered) {
                  hasRendered = true;
                  return (
                    <InputType
                      type="date"
                      value={relatedField?.value || ""}
                      onChange={(e) =>
                        handleInputChange(field.dataName, e.target.value)
                      }
                      required={
                        requiredConditionMet || relatedField?.isRequired
                      }
                      style={inputStyle}
                    />
                  );
                }
                break;
              case "country":
                if (!hasRendered) {
                  hasRendered = true;
                  return (
                    <SelectBorder
                      value={relatedField?.value || ""}
                      onChange={(e) =>
                        handleInputChange(field.dataName, e.target.value)
                      }
                      required={
                        requiredConditionMet || relatedField?.isRequired
                      }
                      style={inputStyle}
                    >
                      <option value="">Select a country</option>
                      {countries.map((country, index) => (
                        <option key={index} value={country}>
                          {country}
                        </option>
                      ))}
                    </SelectBorder>
                  );
                }
                break;
              case "file":
                if (!hasRendered) {
                  hasRendered = true;
                  // 🔒 FIX: agar is field ke liye pehle se koi file upload hai
                  // (draft/edit me), to uska naam file input ke neeche dikhao
                  const existingFiles = uploadedMediaFiles[field.dataName];
                  return (
                    <>
                      <InputType
                        type="file"
                        onChange={(event) =>
                          handleFileChange(event, field.dataName)
                        }
                        style={inputStyle}
                      />
                      {existingFiles && existingFiles.length > 0 && (
                        <p style={{ fontSize: "12px", color: "#555", marginTop: "4px" }}>
                          ✅ Already uploaded: {existingFiles.map((f) => f.file_name).join(", ")}
                          {" "}(Selecting a new file will replace the existing file)
                        </p>
                      )}
                    </>
                  );
                }
                break;
              default:
                return null;
            }
          })()}
          {errors[field.dataName] && (
            <p style={{ color: "red", fontSize: "12px" }}>
              {errors[field.dataName]}
            </p>
          )}
        </div>
      </div>
    );
  };

  const convertFormDataToSimpleObject = (formData) => {
    const result = {};
    Object.entries(formData).forEach(([key, value]) => {
      if (value && value.value) {
        const keyWithoutTimestamp = key;
        result[keyWithoutTimestamp] = value.value;
      }
    });
    return result;
  };
// ✅ HTML tags hatao helper function
const cleanHtmlTags = (html) => {
  if (!html) return '';
  // Remove all HTML tags
  let clean = html.replace(/<[^>]*>/g, '');
  // Remove extra spaces
  clean = clean.replace(/\s+/g, ' ').trim();
  return clean;
};
  // const saveForm = async (e) => {
  //   e.preventDefault();
  //   setLoading(true);

  //   try {
  //     let formIsValid = true;

  //     Object.keys(formData).forEach((key) => {
  //       const field = formData[key];
  //       if (field?.type === "file" && field.file && !field.valid) {
  //         formIsValid = false;
  //         toast.error(`Invalid file in ${key}: Check size and type.`);
  //       }
  //       if (field?.isRequired && !field.value && field.visible) {
  //         formIsValid = false;
  //         toast.error(`Field ${field.label} is required.`);
  //       }
  //     });

  //     if (!formIsValid) {
  //       console.log("Form contains invalid or missing fields.");
  //       setLoading(false);
  //       return;
  //     }

  //     await uploadFilesToBackend();

  //     const convertedData = convertFormDataToSimpleObject(formData);
  //     const formPayload = {
  //       fields: convertedData,
  //       eventId,
  //       entryFormId,
  //       awardcatId: parseInt(selectedAwardId, 10),
  //         isDraft: false, // 🔥 ADD THIS

  //     };

  //     const response = await axios.post(
  //       `${EXCHNAGE_URL}/entryForm_submission`,
  //       formPayload,
  //       {
  //         headers: {
  //           "Content-Type": "application/json",
  //           authorization: `Bearer ${localStorage.getItem("token")}`,
  //         },
  //       },
  //     );

  //     toast.success("Entry Form Submitted Successfully.");
  //     if (userRole === "admin") {
  //       navigate("/dashboard");
  //     } else {
  //       navigate("/user-dashboard");
  //     }
  //   } catch (error) {
  //     console.error("Error creating form:", error.response.data.message);
  //     toast.error(error.response.data.message);
  //   } finally {
  //     setLoading(false);
  //   }
  // };
const saveForm = async (e) => {
  e.preventDefault();
  setLoading(true);

  try {
    let formIsValid = true;
    const missingFields = [];

    Object.keys(formData).forEach((key) => {
      const field = formData[key];
      
      // Skip if field is not visible
      if (field?.visible === false) return;
      
      // File validation
      if (field?.type === "file" && field.file && !field.valid) {
        formIsValid = false;
        toast.error(`Invalid file in ${key}: Check size and type.`);
      }
      
      // Required field validation
      const isFieldRequired = field?.isRequired === true;
      const hasValue = field?.value !== undefined && 
                       field?.value !== null && 
                       field?.value !== '';
      
      if (isFieldRequired && !hasValue) {
        formIsValid = false;
 const cleanLabel = cleanHtmlTags(field?.label) || key;
        missingFields.push(cleanLabel);      }
    });

    if (!formIsValid) {
      if (missingFields.length > 0) {
        toast.error(`Please fill in all required fields: ${missingFields.join(', ')}`);
      } else {
        toast.error('Please fill in all required fields.');
      }
      console.log("Missing fields:", missingFields);
      setLoading(false);
      return;
    }

    await uploadFilesToBackend();

    const convertedData = convertFormDataToSimpleObject(formData);
    const formPayload = {
      fields: convertedData,
      eventId,
      entryFormId,
      awardcatId: parseInt(selectedAwardId, 10),
      isDraft: false,
      // 🔒 FIX: agar user pehle draft save kar chuka hai (ya draft load hua hai),
      // usi submission_id ko bhejo taaki final Submit us DRAFT ko hi convert kare,
      // ek naya alag submission na banaye.
      ...(currentSubmissionId ? { submissionId: currentSubmissionId } : {}),
    };

    const response = await axios.post(
      `${EXCHNAGE_URL}/entryForm_submission`,
      formPayload,
      {
        headers: {
          "Content-Type": "application/json",
          authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      },
    );

    // 🔒 FIX: response se final submissionId capture kar lo (consistency ke liye)
    if (response?.data?.submissionId) {
      setCurrentSubmissionId(response.data.submissionId);
    }

    toast.success("Entry Form Submitted Successfully.");
    if (userRole === "admin") {
      navigate("/dashboard");
    } else {
      navigate("/user-dashboard");
    }
  } catch (error) {
    console.error("Error creating form:", error.response?.data?.message || error.message);
    toast.error(error.response?.data?.message || "Failed to submit form. Please try again.");
  } finally {
    setLoading(false);
  }
};

const draftLoadedRef = useRef(false);
// useEffect(() => {
//   if (!formSchema.length) return;

//   const fetchDraft = async () => {
//     try {
//       const res = await axios.get(
//         `${EXCHNAGE_URL}/getentry?eventId=${eventId}&entryFormId=${entryFormId}&awardcatId=${selectedAwardId || 0}`,
//         {
//           headers: {
//             authorization: `Bearer ${localStorage.getItem("token")}`,
//           },
//         }
//       );

//       const draftData = res.data.data;
// const draftAwardId = res.data.awardcatId;
//       if (!draftData) return;


// if (draftAwardId) {
//   setSelectedAwardId(draftAwardId);

//   const matchedCategory = categories.find(
//     (cat) => cat.awardId === draftAwardId
//   );

//   if (matchedCategory) {
//     setSelectedCategoryName(matchedCategory.category_name);
//   }
// }

//       // 🔥 IMPORTANT: map into existing formData
//       setFormData((prev) => {
//         const updated = { ...prev };

//         Object.keys(draftData).forEach((key) => {
//           if (updated[key]) {
//             updated[key] = {
//               ...updated[key],
//               value: draftData[key],
//             };
//           }
//         });

//         return updated;
//       });

//       toast.success("Draft loaded ✅");
//     } catch (err) {
//       console.log("No draft found");
//     }
//   };

//   fetchDraft();
// }, [formSchema, selectedAwardId,categories]);
useEffect(() => {
  if (
    !formSchema.length ||
    !categories.length ||
    draftLoadedRef.current
  )
    return;

  draftLoadedRef.current = true;

  const fetchDraft = async () => {
    try {
      const res = await axios.get(
        `${EXCHNAGE_URL}/getentry?eventId=${eventId}&entryFormId=${entryFormId}&awardcatId=0`,
        {
          headers: {
            authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );

      const draftData = res.data.data;
      const draftAwardId = res.data.awardcatId;

      if (!draftData) return;

      // 🔒 FIX: existing draft ka submission_id state me store karo,
      // taaki isi form par "Save as Draft" ya "Submit" karne par
      // NAYA submission_id na bane, isi draft ko update kare.
      if (res.data.submission_id) {
        setCurrentSubmissionId(res.data.submission_id);
      }

      // 🔒 FIX: pehle se upload ki hui files bhi state me store karo,
      // taaki file input ke neeche "already uploaded" naam dikha sakein
      if (res.data.media_files) {
        setUploadedMediaFiles(res.data.media_files);
      }

      if (draftAwardId) {
        setSelectedAwardId(draftAwardId);

        const matchedCategory = categories.find(
          (cat) => Number(cat.awardId) === Number(draftAwardId)
        );

        if (matchedCategory) {
          setSelectedCategoryName(matchedCategory.category_name);
        }
      }

      setFormData((prev) => {
        const updated = { ...prev };

        Object.keys(draftData).forEach((key) => {
          if (updated[key]) {
            updated[key] = {
              ...updated[key],
              value: draftData[key],
            };
          }
        });

        return updated;
      });

    } catch (err) {
      console.log("No draft found");
    }
  };

  fetchDraft();
}, [formSchema, categories]);
  return (
    <>
      {isLoading ? (
        <div className="fullscreen-loaderr">
          <div className="loaderr"></div>
        </div>
      ) : (
        <>
          <UserTopBanner
            event_logo={event_logo}
            event_banner={event_banner}
            closing_date={closing_date}
            closing_time={closing_time}
            event_name={event_name}
          />
          <div className="registration_form_main">
            <div className="registration_form">
              <RedMainHeading>Entry Form</RedMainHeading>
            </div>
            <form className="registration_form_div" onSubmit={saveForm}>
              <div className="registration_form_row">
                {isLoading ? (
                  <div className="inline-loaderr">
                    <div className="loaderr"></div>
                  </div>
                ) : (
                  formSchema.map((field) => {
                    const relatedField = formData[field.dataName];
                    const shouldShow = relatedField?.visible;

                    if (!shouldShow) return null;

                    return (
                      <div
                        key={field.dataName}
                        className="registration_form_label"
                      >
                        {renderField(field)}
                      </div>
                    );
                  })
                )}
              </div>
              <div className="registration_form_btn_div">
                <GreyBorderButton type="button" onClick={openCancelModal}>
                  Cancel
                </GreyBorderButton>
                <GreyBorderButton type="button" onClick={handleSaveDraft}>
                  Save as Draft
                </GreyBorderButton>
                <RedBackgroundButton type="submit">Submit</RedBackgroundButton>
              </div>
            </form>
          </div>
          <Modal show={isCancelModalOpen} onHide={closeCancelModal} centered>
            <Modal.Header closeButton>
              <Modal.Title>Confirm Cancellation</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <p>Are you sure you want to cancel? Your changes will be lost.</p>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={closeCancelModal}>
                No, Keep Editing
              </Button>
              <Button variant="danger" onClick={handleCancel}>
                Yes, Cancel
              </Button>
            </Modal.Footer>
          </Modal>
          <UserBottomBar />
        </>
      )}
    </>
  );
};
